import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { baseVariables, toRem } from '../../../styles';
import { PopupFooterProps } from '../Modal.types';

export const StyledPopupFooterDiv = styled.div<PopupFooterProps>`
  ${(props: PopupFooterProps) =>
    props.flexLayout &&
    `
  flex-shrink: 0;
`}
  ${rtl`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: center;
  gap: ${toRem(16)};
  z-index: 2;
  bottom: 0;
  width: 100%;
  max-width: 100%;
  background-color: ${baseVariables.color.neutral10};
  border-top: 1px solid ${baseVariables.color.neutral20};
  padding: ${toRem(24)};
  border-radius: 0;

  .clear-btn-container,
  .view-rates-button-container {
    width: 100%;
    text-align: center;
  }

  .clear-btn-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${toRem(16)};
  }

  .clear-btn-container button {
    margin: 0 !important;
  }

  .clear {
    color: ${baseVariables.color.base10};
    font-size: ${toRem(13)};
    background: transparent;
    padding: 0;
    &:after {
      display: none !important;
    }
    &:focus {
      outline: none;
    }
  }
  .reset-btn {
    text-align: center;
    padding: 0;
    margin-top: ${toRem(11)};
    background: transparent;
    border: none;
  }

  .view-rates-button{
    width: 100%;
    height: ${toRem(40)};
  }

  @media only ${baseVariables.mediaQuery.sm}{
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 0;
    padding: ${toRem(22)} ${toRem(24)};

    .clear-btn-container,
    .view-rates-button-container {
      width: auto;
      text-align: initial;
    }

    .clear-btn-container {
      flex-direction: row;
      gap: 0;
    }

    .clear-btn-container button {
      margin-right: ${toRem(24)} !important;
    }

    .view-rates-button{
      width: ${toRem(166)};
    }
  }

  @media only ${baseVariables.mediaQuery.md}{
    border-radius: 0 0 ${toRem(14)} ${toRem(14)};
  }

  @media only ${baseVariables.mediaQuery.lg}{
    ${(props: PopupFooterProps) => (props.flexLayout ? `height: ${toRem(104)}` : `height: auto;`)}
  }

  ${(props: PopupFooterProps) =>
    props.flexLayout &&
    `
    @media only ${baseVariables.mediaQuery.sm} {
      padding: ${toRem(22)} ${toRem(32)} !important;
    }
  `}`}
`;

export const StyledApplyButtonDiv = styled.div`
  ${rtl`
  width: 100%;

  .apply-button-container {
    margin: ${toRem(28)} 0;
    display: flex;
    align-items: center;
    justify-items: center;
    color: ${baseVariables.color.alert10};
  }
  .apply-button {
    height: ${toRem(40)};
    width: 100% !important;
    background-color: ${baseVariables.color.base10};
    border-radius: ${toRem(20)};
    justify-content: center;
    align-items: center;
    display: flex;
    color: ${baseVariables.color.alert10};
  }

  @media only ${baseVariables.mediaQuery.sm} {
    width: auto;
    .apply-button {
      width: ${toRem(128)} !important;
    }
  }
  `}
`;
